import { useIsMobile } from "../../hooks/useIsMobile";

export const PointerIcon = () => {
  const isMobile = useIsMobile();

  return (
    <svg
      width={isMobile ? 28 : 30}
      height={isMobile ? 30 : 32}
      viewBox="0 0 24 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_270_2009)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7133 17.8231L18.1258 17.2778L4.50525 4.66797L4.7111 23.0079L9.47756 18.7781L12.2758 25.0417L14.5115 24.0867L11.7133 17.8231Z"
          fill="white"
        />
        <path
          d="M12.4569 18.2616L18.1682 17.776L19.2963 17.68L18.4655 16.9109L4.84493 4.30106L3.99224 3.51165L4.00528 4.67358L4.21113 23.0135L4.22343 24.1091L5.04297 23.3819L9.29926 19.6048L11.8192 25.2457L12.0199 25.6947L12.4722 25.5015L14.708 24.5465L15.1754 24.3468L14.9681 23.8828L12.4569 18.2616Z"
          stroke="black"
          strokeOpacity="0.8"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_270_2009"
          x="0.479248"
          y="0.355469"
          width="22.9875"
          height="29.9922"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_270_2009"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_270_2009"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
